import { getRegisterFunction } from '../../utils/register.js';
import { OneUxSearchElement } from './OneUxSearchElement.js';
export const register = getRegisterFunction(OneUxSearchElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-search': OneUxSearchElement;
    "search-2fe9df8956da47139e4eb51f0fdad3ef": OneUxSearchElement;
  }
}